import { render, staticRenderFns } from "./index.v2.vue?vue&type=template&id=7e87dd39&scoped=true&"
import script from "./index.v2.vue?vue&type=script&lang=js&"
export * from "./index.v2.vue?vue&type=script&lang=js&"
import style0 from "./index.v2.vue?vue&type=style&index=0&id=7e87dd39&lang=scss&scoped=true&"
import style1 from "./index.v2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87dd39",
  null
  
)

export default component.exports